import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import Loader from '../../../common/Loader.js'
import CustomFooter from '../../../common/TableBottom.js'
import Moment from 'react-moment'
import { Modal } from 'react-responsive-modal'
import Button from '../../../common/CustomComponents/Button.js'
class VoucherHistory extends React.Component {
  state = {
    isLoading: false,

    listCountries: [],
    voucherHistoryList: [],

    country: localStorage.getItem('countryShortName') || 'KWT',
    limit: 10,
    pageNumber: 0,

    totalPages: 0,
    disabled: false,
    redeemVoucherModal: false,
    voucher_code: '',
  }

  componentDidMount() {
    if (this.props.customer_id) {
      this.getVoucherHistory()
    }
  }

  async getVoucherHistory() {
    this.setState({ isLoading: true })

    await axios
      .get(Constant.getAPI() + '/user/voucher-history/', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          user_id: this.props.customer_id,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          country: this.state.country,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            voucherHistoryList: res?.data?.data?.history || [],
            walletAmount: res?.data?.data?.walletAmount || 0,
            currency: res?.data?.data?.currency || 'KWD',

            totalPages: res.data?.pagination?.pages,
            disabled: this.state.pageNumber + 1 >= res.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  redeemVoucher() {
    this.setState({ isLoading: true })
    const data = {
      code: this.state.voucher_code,
      country: this.state.country,
      user_id: this.props.customer_id,
    }

    axios
      .post(Constant.getAPI() + '/user/redeem-voucher', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ redeemVoucherModal: false, voucher_code: '' })
          this.getVoucherHistory()
          Swal.fire('Success !', 'Voucher redeemed successfully', 'success')
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleOnClick() {
    this.setState({
      redeemVoucherModal: true,
      voucher_code: '',
    })
  }

  handleRefund = (orderId) => {
    Swal.fire({
      title: 'Process refund?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ isLoading: true })
        const data = {
          order_id: orderId,
        }
        axios
          .post(Constant.getAPI() + '/admin/refund-voucher', data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then((res) => {
            if (res.data.success) {
              this.getVoucherHistory()
              Swal.fire('Success !', 'Voucher refunded successfully', 'success')
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
          .finally(() => {
            this.setState({ isLoading: false })
          })
      }
    })
  }

  validateRefund = (value, tableMeta) => {
    const status = tableMeta.rowData[3]
    const redeemedBy = Object.keys(tableMeta.rowData[5]).length === 0
    return status === 'Created' && value === 0 && redeemedBy
  }

  render() {
    const customToolbar = () => {
      return (
        <div className="row">
          <div className="col-11">
            <div
              className=""
              style={{ marginTop: 10, fontWeight: 500, fontSize: 20 }}
            >
              {'Available Balance:- ' + this.state.walletAmount + ' ' + this.state.currency + ' '}
            </div>
          </div>
          <div className="col-1">
            <div className="offset-6">
              <Button onClick={() => this.handleOnClick()}>Redeem Voucher</Button>
            </div>
          </div>
        </div>
      )
    }
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          display: false,
        },
      },
      {
        name: 'image',
        label: 'Image',
        options: {
          customBodyRender: (value) => {
            return (
              <>
                <img
                  src={Constant.getImage() + value}
                  className="img-fluid img-50"
                  alt="img"
                  onError={(event) => {
                    event.currentTarget.src = './assets/images/no_image.png'
                  }}
                  style={{ borderRadius: 25 }}
                />
              </>
            )
          },
        },
      },
      // {
      //     name: 'title',
      //     label: 'Title',
      //     options: {
      //         customBodyRender: (data) => {
      //             return data || '--'
      //         },
      //     },
      // },
      {
        name: 'code',
        label: 'Voucher Code',
        options: {
          customBodyRender: (data, tableMeta) => {
            return (
              <>
                <span>{data}</span>
                {' - '}
                {tableMeta.rowData[6]?.id == this.props.customer_id &&
                  !tableMeta.rowData[5]?.id &&
                  !tableMeta.rowData[8] && (
                    <Button
                      variant="only-text"
                      onClick={() => {
                        this.setState({
                          redeemVoucherModal: true,
                          voucher_code: data,
                        })
                      }}
                    >
                      Redeem
                    </Button>
                  )}
              </>
            )
          },
        },
      },
      {
        name: 'status',
        label: 'Status',
        options: {
          customBodyRender: (data) => {
            return data
          },
        },
      },
      {
        name: 'amount',
        label: 'Amount',
        options: {
          customBodyRender: (data) => {
            return (
              <>
                {data > 0 ? (
                  <span className="text-success font-weight-bold">{data}</span>
                ) : (
                  <span className="text-danger font-weight-bold">{data}</span>
                )}
              </>
            )
          },
        },
      },
      {
        name: 'redeemed_by',
        label: 'Redeemed By',
        options: {
          customBodyRender: (obj) => {
            return (
              <>
                <span>Email: {obj?.email || '--'}</span>
                <br></br>
                <span>Phone: {obj?.phone || '--'}</span>
              </>
            )
          },
        },
      },
      {
        name: 'created_by',
        label: 'Created By',
        options: {
          customBodyRender: (obj) => {
            return (
              <>
                <span>Email: {obj?.email || '--'}</span>
                <br></br>
                <span>Phone: {obj?.phone || '--'}</span>
              </>
            )
          },
        },
      },
      {
        name: 'created_at',
        label: 'Transaction Date',
        options: {
          customBodyRender: (data) => {
            return <Moment format="YYYY-MM-DD hh:mm:ss A">{data}</Moment>
          },
        },
      },
      {
        name: 'is_refunded',
        label: 'Action',
        options: {
          customBodyRender: (value, tableMeta) => {
            const orderId = tableMeta.rowData[0]
            return (
              this.validateRefund(value, tableMeta) && (
                <Button onClick={() => this.handleRefund(orderId)}>Refund</Button>
              )
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: false,
      filter: false,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            count={this.state.limit}
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
            bookingList: [],
          },
          () => {
            this.getVoucherHistory()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            bookingList: [],
          },
          () => {
            this.getVoucherHistory()
          }
        )
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <>
        <div className="page-body">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-block">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      title={customToolbar()}
                      className="table-responsive"
                      data={this.state.voucherHistoryList}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          open={this.state.redeemVoucherModal}
          onClose={() => {
            this.setState({ redeemVoucherModal: false })
          }}
          center
        >
          <div className="pcoded-inner-content">
            <div className="header">
              <b>Redeem Voucher</b>
            </div>
            <div className="body m-t-20">
              <div className="row">
                <div className="col-12">
                  <div className="form-group row">
                    <label className="col-3 col-form-label">Voucher Code</label>
                    <div className="col-9">
                      <input
                        type="text"
                        className="form-control"
                        name="voucher_code"
                        id="voucher_code"
                        placeholder={`Voucher Code`}
                        onChange={this.handleChange}
                        value={this.state.voucher_code}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="text-right col-6 offset-6">
                  <Button
                    disabled={this.state.voucher_code?.length < 1}
                    onClick={() => this.redeemVoucher()}
                  >
                    Redeem
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }
}

export default VoucherHistory
